"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasRendererSharedState = void 0;
const entity_buffer_store_1 = require("../buffers/entity-buffer-store");
/**
 * @public
 * Canvas state shared between draw calls. Some methods use the state stack, refer to documentation on individual
 * methods for usage notes.
 */
class CanvasRendererSharedState {
    constructor(context) {
        this.context = context;
        this.frameCounter = 0;
        this.scissorRange = null;
        this.entityBuffers = new entity_buffer_store_1.EntityBufferStore();
    }
    onNewFrame() {
        ++this.frameCounter;
    }
    onContextLost() {
        // not currently required
    }
    /**
     * Where multiple ranges are provided the scissor range will be the intersection of these. Each of these must be
     * popped of the stack individually.
     */
    updateScissorRange(scissorRange) {
        this.scissorRange = scissorRange;
        if (scissorRange == null) {
            this.context.restore();
        }
        else {
            this.context.save();
            this.context.beginPath();
            this.context.rect(scissorRange.getXMin() | 0, scissorRange.getYMin() | 0, scissorRange.getXRange() | 0, scissorRange.getYRange() | 0);
            this.context.closePath();
            this.context.clip();
        }
    }
    setContext(context) {
        this.context = context;
    }
}
exports.CanvasRendererSharedState = CanvasRendererSharedState;
//# sourceMappingURL=canvas-renderer-shared-state.js.map